import jishikaijiang from '../../Jishikaijiang/columns/hpten';
export default {
  list: Vue => {
    return jishikaijiang().list(Vue);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/History/columns/hpten.js